export const checkRequirementCompleted = (parsedValue, requirements, print_with_gpds_id, gpds_id) => {
  const needRequirements = requirements.filter((req) => allowedRequirement(req.model));
  let required = needRequirements.length == 0 || needRequirements.every((req) => parsedValue[req.model]);
  if (print_with_gpds_id) {
    required = required && !!gpds_id;
  }
  return required;
};

export const allowedRequirement = (model) => {
  return model == 'date' || model == 'guest' || model == 'relative' || model == 'user';
};

export const assignParsedValue = (parsedValue, selected, name) => {
  return {
    ...parsedValue,
    [name]: selected.data_selected,
  };
};
